document.addEventListener('DOMContentLoaded', function () {
  // ------------------------------------------
  // Input-mode detector (for focus outlines)
  // ------------------------------------------
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') document.body.classList.add('user-is-tabbing');
  });
  document.addEventListener('mousedown', () => {
    document.body.classList.remove('user-is-tabbing');
  });

  // ------------------------------------------
  // Elements
  // ------------------------------------------
  const cartDrawer         = document.getElementById('nellaFinanceDrawer');
  const plansSection       = document.getElementById('financingPlansSection');
  const contactFormSection = document.getElementById('contactFormSection');
  const toggleContactBtn   = document.getElementById('contactToggleBtn');
  const footerButtons      = document.getElementById('footerButtons');
  const contactFormFooter  = document.getElementById('contactFormFooter');
  const backIconBtn        = document.getElementById('contactBackIconBtn');
  const radios             = document.querySelectorAll('.plan-check');

  const leasingForm = document.getElementById('leasing_contact_form');
  const hiddenFinancingTerm = leasingForm?.querySelector('input[name="contact[financing_term]"]');

  const nameInput = document.getElementById('LeasingContactFormName')
                  || contactFormSection?.querySelector('input[name="contact[name]"]');

  const emailInput = document.getElementById('LeasingContactFormEmail')
                  || contactFormSection?.querySelector('input[name="contact[email]"]');

  const phoneInput = document.getElementById('LeasingContactFormPhone')
                  || contactFormSection?.querySelector('input[name="contact[phone]"]');

  const submitBtn = document.getElementById('contactSubmitBtn')
                  || contactFormFooter?.querySelector('button[type="submit"]');

  // ✅ scroll container (offcanvas-body is the scroller after your CSS changes)
  const drawerScroller =
    cartDrawer?.querySelector('.offcanvas-body') ||
    cartDrawer?.querySelector('.nella-drawer-scrollable-content') ||
    cartDrawer;

  // Header title elements
  const headerEl = cartDrawer?.querySelector('.offcanvas-header');
  const titleEl  = cartDrawer?.querySelector('.offcanvas-title');
  const closeEl  = cartDrawer?.querySelector('.btn-close');

  // ------------------------------------------
  // Helpers
  // ------------------------------------------
  function scrollDrawerToTop() {
    requestAnimationFrame(() => {
      try {
        if (drawerScroller && typeof drawerScroller.scrollTo === 'function') {
          drawerScroller.scrollTo({ top: 0, left: 0 });
        } else if (drawerScroller) {
          drawerScroller.scrollTop = 0;
        }
      } catch (_) {
        if (drawerScroller) drawerScroller.scrollTop = 0;
      }
    });
  }

  function openDrawer() {
    if (!cartDrawer) return;
    const openNow = () => {
      try {
        if (window.bootstrap && bootstrap.Offcanvas) {
          bootstrap.Offcanvas.getOrCreateInstance(cartDrawer).show();
        } else {
          cartDrawer.classList.add('show');
          cartDrawer.style.visibility = 'visible';
        }
      } catch (_) {}
    };
    if (window.bootstrap?.Offcanvas) openNow(); else setTimeout(openNow, 0);
  }

  function closeDrawer() {
    if (!cartDrawer) return;
    try {
      if (window.bootstrap && bootstrap.Offcanvas) {
        bootstrap.Offcanvas.getOrCreateInstance(cartDrawer).hide();
      } else {
        cartDrawer.classList.remove('show');
        cartDrawer.style.visibility = '';
      }
    } catch (_) {}
    // Strip body classes directly — hidden.bs.offcanvas may not fire before freeze
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
  }

  function showContactForm() {
    plansSection?.classList.add('d-none');
    contactFormSection?.classList.remove('d-none');
    footerButtons?.classList.add('d-none');
    contactFormFooter?.classList.remove('d-none');
  }

  function showPlans() {
    plansSection?.classList.remove('d-none');
    contactFormSection?.classList.add('d-none');
    footerButtons?.classList.remove('d-none');
    contactFormFooter?.classList.add('d-none');
  }

  function updateHiddenTerm(radio) {
    if (!hiddenFinancingTerm) return;
    hiddenFinancingTerm.value = (radio && radio.checked) ? radio.value : '';
  }

  function clearSelection() {
    radios.forEach(r => { r.checked = false; r.blur(); });
    updateHiddenTerm(null);
    lastChecked = null;
  }

  // ------------------------------------------
  // Tooltip helpers (Bootstrap tooltip if available)
  // ------------------------------------------
  function showFieldTooltip(el, msg) {
    if (!el) return;

    // keep message in title for accessibility + fallback
    el.setAttribute('title', msg);

    try {
      if (window.bootstrap && bootstrap.Tooltip) {
        el.setAttribute('data-bs-title', msg);
        el.setAttribute('data-bs-toggle', 'tooltip');

        const inst = bootstrap.Tooltip.getInstance(el) || new bootstrap.Tooltip(el, {
          trigger: 'manual',
          placement: 'top',
          container: 'body'
        });

        inst.setContent({ '.tooltip-inner': msg });
        inst.show();
      }
    } catch (_) {}
  }

  function hideFieldTooltip(el) {
    if (!el) return;
    try {
      if (window.bootstrap && bootstrap.Tooltip) {
        const inst = bootstrap.Tooltip.getInstance(el);
        inst?.hide();
        inst?.dispose();
      }
    } catch (_) {}
    el.removeAttribute('data-bs-toggle');
    el.removeAttribute('data-bs-title');
  }

  // ------------------------------------------
  // Validation helpers
  // ------------------------------------------
  function markInvalid(el, msg) {
    if (!el) return;
    el.classList.add('is-invalid');
    try { el.setCustomValidity(msg || 'Invalid'); } catch (_) {}
    showFieldTooltip(el, msg || 'Invalid');
  }

  function clearInvalid(el) {
    if (!el) return;
    el.classList.remove('is-invalid');
    try { el.setCustomValidity(''); } catch (_) {}
    hideFieldTooltip(el);
  }

  function isValidEmailStrict(val) {
    const v = String(val || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  // Accept extensions: x123 / ext 123 / #123
  function isValidPhoneWithExtension(val) {
    const raw = String(val || '').trim();
    const main = raw.replace(/\s*(?:ext\.?|x|#)\s*\d+\s*$/i, '');
    const digits = main.replace(/\D/g, '');

    if (digits.length === 10) return true;
    if (digits.length === 11 && digits.startsWith('1')) return true;
    return false;
  }

  function normalizePhoneExtensionFormat() {
    if (!phoneInput) return;
    phoneInput.value = phoneInput.value
      .replace(/\s*(ext\.?|x|#)\s*/i, ' x')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // ------------------------------------------
  // ✅ Disable native HTML tooltip ONLY for email + phone (but keep native for others)
  // We do this by temporarily removing constraints for those fields during submit.
  // ------------------------------------------
  const _nativeConstraints = {
    email: null,
    phone: null
  };

  function storeNativeConstraintsOnce() {
    if (emailInput && !_nativeConstraints.email) {
      _nativeConstraints.email = {
        type: emailInput.getAttribute('type'),
        required: emailInput.hasAttribute('required'),
        pattern: emailInput.getAttribute('pattern'),
        inputmode: emailInput.getAttribute('inputmode')
      };
    }
    if (phoneInput && !_nativeConstraints.phone) {
      _nativeConstraints.phone = {
        type: phoneInput.getAttribute('type'),
        required: phoneInput.hasAttribute('required'),
        pattern: phoneInput.getAttribute('pattern'),
        inputmode: phoneInput.getAttribute('inputmode')
      };
    }
  }

  function disableNativeValidationUIForEmailPhone() {
    storeNativeConstraintsOnce();

    // Remove constraints so browser won't show its tooltip for these fields
    if (emailInput) {
      emailInput.removeAttribute('required');
      emailInput.removeAttribute('pattern');
      // switch to text so browser doesn't run email validity UI
      emailInput.setAttribute('type', 'text');
      // keep keyboard nice
      emailInput.setAttribute('inputmode', 'email');
    }

    if (phoneInput) {
      phoneInput.removeAttribute('required');
      phoneInput.removeAttribute('pattern');
      phoneInput.setAttribute('type', 'text');
      phoneInput.setAttribute('inputmode', 'tel');
    }
  }

  function restoreNativeValidationForEmailPhone() {
    // Put attributes back (so HTML validation logic exists in markup / for non-JS paths)
    if (emailInput && _nativeConstraints.email) {
      const c = _nativeConstraints.email;
      if (c.required) emailInput.setAttribute('required', 'required'); else emailInput.removeAttribute('required');
      if (c.pattern != null) emailInput.setAttribute('pattern', c.pattern); else emailInput.removeAttribute('pattern');
      if (c.type) emailInput.setAttribute('type', c.type); else emailInput.removeAttribute('type');
      if (c.inputmode) emailInput.setAttribute('inputmode', c.inputmode); else emailInput.removeAttribute('inputmode');
    }

    if (phoneInput && _nativeConstraints.phone) {
      const c = _nativeConstraints.phone;
      if (c.required) phoneInput.setAttribute('required', 'required'); else phoneInput.removeAttribute('required');
      if (c.pattern != null) phoneInput.setAttribute('pattern', c.pattern); else phoneInput.removeAttribute('pattern');
      if (c.type) phoneInput.setAttribute('type', c.type); else phoneInput.removeAttribute('type');
      if (c.inputmode) phoneInput.setAttribute('inputmode', c.inputmode); else phoneInput.removeAttribute('inputmode');
    }
  }

  // ------------------------------------------
  // ✅ Title fit (PRE-OPEN): run on ready + only when width changes
  // ------------------------------------------
  let defaultFontPx = null;
  let lastFitKey = '';

  function captureDefaultsOnce() {
    if (!titleEl || defaultFontPx !== null) return;
    const cs = window.getComputedStyle(titleEl);
    defaultFontPx = parseFloat(cs.fontSize) || 16;
  }

  function resetTitleToCssDefaults() {
    if (!titleEl) return;
    titleEl.style.removeProperty('font-size');
    titleEl.style.removeProperty('letter-spacing');
  }

  function fitTitleToHeaderWidth() {
    if (!headerEl || !titleEl) return;

    captureDefaultsOnce();

    const headerRect = headerEl.getBoundingClientRect();
    const headerW = Math.round(headerRect.width);
    if (!headerW) return;

    const csHeader = window.getComputedStyle(headerEl);
    const padL = parseFloat(csHeader.paddingLeft) || 0;
    const padR = parseFloat(csHeader.paddingRight) || 0;
    const closeW = closeEl ? Math.ceil(closeEl.getBoundingClientRect().width) : 44;

    const key = `${headerW}:${padL}:${padR}:${closeW}`;
    if (key === lastFitKey) return;
    lastFitKey = key;

    const available = headerW - padL - padR;
    if (available <= 0) return;

    resetTitleToCssDefaults();

    const fits = () => titleEl.scrollWidth <= titleEl.clientWidth + 1;
    if (fits()) return;

    const csTitle = window.getComputedStyle(titleEl);
    const baseLS = (csTitle.letterSpacing === 'normal') ? 0 : (parseFloat(csTitle.letterSpacing) || 0);
    let fontPx = parseFloat(csTitle.fontSize) || defaultFontPx || 16;

    const MIN_FONT_PX = 12.5;
    const MIN_LS_PX = -0.8;

    let steps = 0;
    while (!fits() && steps < 24 && fontPx > MIN_FONT_PX) {
      fontPx -= 0.5;
      titleEl.style.fontSize = `${fontPx}px`;

      if (!fits()) {
        const nextLS = Math.max(MIN_LS_PX, baseLS - (0.1 * (steps + 1)));
        titleEl.style.letterSpacing = `${nextLS}px`;
      }
      steps++;
    }
  }

  function initTitleFit() {
    requestAnimationFrame(() => requestAnimationFrame(fitTitleToHeaderWidth));
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initTitleFit).catch(initTitleFit);
  } else {
    initTitleFit();
  }

  if (window.ResizeObserver && headerEl) {
    const ro = new ResizeObserver(() => {
      requestAnimationFrame(() => fitTitleToHeaderWidth());
    });
    ro.observe(headerEl);
  } else {
    window.addEventListener('resize', () => requestAnimationFrame(fitTitleToHeaderWidth));
    window.addEventListener('orientationchange', () => setTimeout(fitTitleToHeaderWidth, 100));
  }

  // ------------------------------------------
  // Drawer lifecycle
  // ------------------------------------------
  cartDrawer?.addEventListener('shown.bs.offcanvas', () => {
    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    scrollDrawerToTop();

  });

  cartDrawer?.addEventListener('hidden.bs.offcanvas', () => {
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
    showPlans();
    clearSelection();
    scrollDrawerToTop();

    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
    }

    [nameInput, emailInput, phoneInput].forEach(hideFieldTooltip);
    restoreNativeValidationForEmailPhone();
  });

  // Contact Sales → open drawer at Contact
  toggleContactBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
    showContactForm();
    scrollDrawerToTop();

  });

  // Back to plans
  backIconBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    showPlans();
    scrollDrawerToTop();
  });

  // ------------------------------------------
  // Radios: toggleable + hidden term sync
  // ------------------------------------------
  let lastChecked = null;

  radios.forEach(radio => {
    radio.addEventListener('click', function () {
      if (lastChecked === this) {
        this.checked = false;
        lastChecked = null;
        updateHiddenTerm(null);
        this.blur();
      } else {
        lastChecked = this;
        updateHiddenTerm(this);
      }
    });

    radio.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        if (lastChecked === radio) {
          radio.checked = false;
          lastChecked = null;
          updateHiddenTerm(null);
        } else {
          radio.checked = true;
          lastChecked = radio;
          updateHiddenTerm(radio);
        }
      }
    });
  });

  // ------------------------------------------
  // Inputs: clear tooltip + restore native attributes when editing
  // ------------------------------------------
  [nameInput, emailInput, phoneInput].forEach((el) => {
    el?.addEventListener('input', () => {
      clearInvalid(el);
      // once user edits, restore native attributes for future loads (optional)
      restoreNativeValidationForEmailPhone();
    });

    el?.addEventListener('blur', () => {
      if (el === phoneInput) normalizePhoneExtensionFormat();
    });
  });

  // ------------------------------------------
  // Submit:
  // - Keep native browser validation for everything EXCEPT email/phone tooltip UI.
  // - Email/phone are validated by JS + tooltip only.
  // ------------------------------------------
  leasingForm?.addEventListener('submit', (e) => {
    // Sync hidden term
    const checked = leasingForm.querySelector('.plan-check:checked');
    updateHiddenTerm(checked || null);

    showContactForm();

    // Make sure email/phone won't trigger native bubbles
    disableNativeValidationUIForEmailPhone();

    // 1) Run native validation for remaining fields (e.g., Name required)
    // If invalid, let browser handle it (name bubble, etc.)
    if (!leasingForm.checkValidity()) {
      // restore attributes so the markup stays correct after the attempt
      restoreNativeValidationForEmailPhone();
      return;
    }

    // 2) JS-only validation for email + phone (tooltip only)
    let ok = true;

    if (emailInput) {
      clearInvalid(emailInput);
      const v = emailInput.value.trim();
      if (!v) { markInvalid(emailInput, 'Please enter your email.'); ok = false; }
      else if (!isValidEmailStrict(v)) { markInvalid(emailInput, 'Please enter a valid email (example: name@domain.com).'); ok = false; }
    }

    if (phoneInput) {
      clearInvalid(phoneInput);
      normalizePhoneExtensionFormat();
      const v = phoneInput.value.trim();
      if (!v) { markInvalid(phoneInput, 'Please enter your phone number.'); ok = false; }
      else if (!isValidPhoneWithExtension(v)) { markInvalid(phoneInput, 'Enter a valid phone number (10 digits; extensions allowed like x123).'); ok = false; }
    }

    if (!ok) {
      e.preventDefault();
      e.stopPropagation();
      scrollDrawerToTop();

      // Focus first invalid among email/phone
      const first = contactFormSection?.querySelector('.is-invalid');
      if (first?.focus) first.focus();

      // restore attributes for next attempt (so your HTML stays as you authored it)
      restoreNativeValidationForEmailPhone();
      return;
    }

    // 3) Passed → proceed to Shopify POST
    try { sessionStorage.setItem('submittedContactFormId', 'leasing_contact_form'); } catch (_) {}

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    // Restore attributes immediately (Shopify will reload anyway)
    restoreNativeValidationForEmailPhone();
  });

  // ------------------------------------------
  // Auto-open drawer on return so Shopify success/errors become visible
  // ------------------------------------------
  (function autoOpenOnReturn(){
    let savedId = null;
    try { savedId = sessionStorage.getItem('submittedContactFormId'); } catch (_) {}

    if (savedId === 'leasing_contact_form') {
      openDrawer();
      showContactForm();
      scrollDrawerToTop();

      leasingForm?.querySelectorAll('[data-contact-success],[data-contact-errors]')
        .forEach(el => el.removeAttribute('hidden'));

    }

    try { sessionStorage.removeItem('submittedContactFormId'); } catch(_){}
  })();

  // Before the browser freezes this page into bfcache, close any open drawer
  // so the snapshot starts in the closed state. Prevents stale overflow-hidden /
  // cart-drawer-open body classes surviving on restore. Body classes are also
  // stripped directly since hidden.bs.offcanvas may not fire before freeze.
  window.addEventListener('pagehide', function (event) {
    if (!event.persisted) return;
    if (cartDrawer && cartDrawer.classList.contains('show')) {
      closeDrawer();
    }
  });

  // Safety net: if the browser restores from bfcache without honouring the
  // pagehide cleanup, force-close any stale open drawer or body classes here.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var stale = (cartDrawer && cartDrawer.classList.contains('show')) ||
      document.body.classList.contains('cart-drawer-open');
    if (stale) {
      closeDrawer();
    }
  });
});
